// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, CanActivate, RouterStateSnapshot } from '@angular/router';
import { FlagsService } from './flags.service';

@Injectable()
export class FlagsGuardService implements CanActivate {
  constructor(private router: Router, private flagsService: FlagsService) {}

  canActivate(router: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.flagsService.allowed('FLAG_MEMBERSHIPS')) {
      return true;
    }

    this.router.navigate(['']);
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/flags-guard.service.ts